import React from 'react';

import Link from 'components/shared/Link';
import Menu from 'components/shared/Menu/';

function Support() {
  const menuItems = [
    <Link
      role="menuitem"
      type="no-style"
      id="support_link"
      href="https://support.bayphoto.com/s/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Help & FAQs
    </Link>,
    <Link
      role="menuitem"
      type="no-style"
      id="specials_link"
      href="https://bayphoto.com/specials/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Specials
    </Link>,
    <Link
      role="menuitem"
      type="no-style"
      id="product_templates_link"
      href="https://bayphoto.com/product-templates/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Templates
    </Link>,
    <Link
      role="menuitem"
      type="no-style"
      id="production_times_link"
      href="https://bayphoto.com/production-times/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Production Times
    </Link>,
    <Link
      role="menuitem"
      type="no-style"
      id="shipping_policies_link"
      href="https://bayphoto.com/shipping-policies/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Shipping Policies
    </Link>,
  ];

  return (
    <div className="support_container">
      <Menu
        appearance="light"
        className="nav_link mobile-support-menu"
        menuItems={menuItems}
        triggerText="Support"
        triggerIcon="question-circle"
        triggerId="support-menu-trigger-mobile"
        iconOnlyTrigger
      />
      <Menu
        className="nav_link support-menu"
        menuItems={menuItems}
        appearance="light"
        triggerId="support-menu-trigger"
        triggerText="Support"
        position="right"
      />
    </div>
  );
}

export default Support;
